import { useEffect, useState } from "react";
import {
  Button,
  IconButton,
  List,
  LinearProgress,
  Typography,
} from "@material-ui/core";
import { Add as AddIcon, Delete } from "@material-ui/icons";
import EditIcon from "@material-ui/icons/Edit";
import ListItem from "../components/ListItem";
import { Video } from "../../../../shared/types";
import { VideoActions } from "../../actions/videos";
import { useNavigate } from "react-router-dom";
import { DEFAULT_VIDEO_THUMB } from "../../helpers/defaults";

const VideosPage = () => {
  const navigate = useNavigate();
  const [videos, setVideos] = useState<Video[]>([]);
  const [loading, setLoading] = useState(true);
  useEffect(() => {
    fetchData();

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const fetchData = async () => {
    const response = await VideoActions.getAll({});
    setVideos(response.data);
    if (!response.failed) setLoading(false);
  };

  const handleClick = (id: string) => {
    navigate(`/backend/video/${id}`);
  };

  const handleNewClick = () => {
    navigate(`/backend/video/`);
  };

  const handleDelete = (id: string) => {
    VideoActions.remove(id);
  };

  return (
    <>
      <Typography>Videos</Typography>
      <Button variant="contained" color="primary" onClick={handleNewClick}>
        Nuevo
      </Button>
      <IconButton onClick={handleNewClick}>
        <AddIcon />
      </IconButton>
      {loading ? (
        <LinearProgress />
      ) : (
        <List>
          {videos.map((w) => (
            <ListItem
              image={w.thumbnail?.path ?? DEFAULT_VIDEO_THUMB}
              key={w.id}
              title={w.label ?? "Video sin título"}
              icons={[
                { action: () => handleClick(w.id ?? ""), icon: <EditIcon /> },
                { action: () => handleDelete(w.id ?? ""), icon: <Delete /> },
              ]}
            />
          ))}
        </List>
      )}
    </>
  );
};

export default VideosPage;
